import { render, staticRenderFns } from "./InputFiles.vue?vue&type=template&id=5fb8146e&scoped=true&"
import script from "./InputFiles.vue?vue&type=script&lang=js&"
export * from "./InputFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb8146e",
  null
  
)

export default component.exports